import { render, staticRenderFns } from "./location-emails-page.vue?vue&type=template&id=866a3ae0&scoped=true"
import script from "./location-emails-page.vue?vue&type=script&lang=js"
export * from "./location-emails-page.vue?vue&type=script&lang=js"
import style0 from "./location-emails-page.vue?vue&type=style&index=0&id=866a3ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866a3ae0",
  null
  
)

export default component.exports